import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Snackbar, styled, Typography, useTheme } from "@mui/material";
import { createContext, forwardRef, useCallback, useContext, useMemo, useState } from "react";
import Icon from "../icon/Icon";
import { Sizes, Success24Fill, Warning24FillRed } from "../icon/IconList";
const BrandSnackbarContext = /*#__PURE__*/ createContext(undefined);
export const useBrandSnackbar = (variants, defaultProps)=>{
    const context = useContext(BrandSnackbarContext);
    if (!context) {
        throw new Error("useBrandSnackbar must be used within a BrandSnackbarProvider");
    }
    const showSnackbar = (message, icon, props)=>{
        if (typeof message === "string" && variants && variants[message]) {
            const variant = variants[message];
            if (typeof variant === "object" && "text" in variant) {
                context.showSnackbar(variant.text, variant.icon, {
                    ...defaultProps,
                    ...props
                });
            } else {
                context.showSnackbar(variant, icon, {
                    ...defaultProps,
                    ...props
                });
            }
        } else if (typeof message === "object" && "text" in message) {
            context.showSnackbar(message.text, message.icon, {
                ...defaultProps,
                ...props
            });
        } else {
            context.showSnackbar(message, icon, {
                ...defaultProps,
                ...props
            });
        }
    };
    return {
        showSnackbar
    };
};
export const SnackbarProvider = (param)=>{
    let { children  } = param;
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState({
        text: ""
    });
    const [snackbarProps, setSnackbarProps] = useState({});
    const showSnackbar = useCallback((text, icon, props)=>{
        setMessage({
            text,
            icon
        });
        setSnackbarProps(props || {});
        setOpen(true);
    }, []);
    const handleClose = useCallback(()=>{
        setOpen(false);
    }, []);
    const contextValue = useMemo(()=>({
            showSnackbar
        }), [
        showSnackbar
    ]);
    return /*#__PURE__*/ _jsxs(BrandSnackbarContext.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ _jsx(BrandSnackbar, {
                ...defaultSnackbarProps,
                ...snackbarProps,
                open: open,
                onClose: handleClose,
                sx: {
                    ...theme.typography.subtitle1,
                    backgroundColor: theme.palette.grey[700],
                    width: "fit-content",
                    minWidth: "320px",
                    padding: "12px 12px",
                    fontSize: "16px",
                    borderRadius: "6px",
                    textAlign: "left",
                    justifyContent: "flex-start"
                },
                children: /*#__PURE__*/ _jsx(IconWithSnackbarMessage, {
                    text: message.text,
                    icon: message.icon
                })
            })
        ]
    });
};
const IconWithSnackbarMessage = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { text , icon  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(SnackbarMessage, {
        ref: ref,
        children: [
            icon === "success" && /*#__PURE__*/ _jsx(Typography, {
                color: (theme)=>theme.palette.success.main,
                sx: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Success24Fill,
                    size: Sizes.medium
                })
            }),
            icon === "warning" && /*#__PURE__*/ _jsx(Icon, {
                icon: Warning24FillRed,
                size: Sizes.medium,
                color: theme.palette.status.error
            }),
            /*#__PURE__*/ _jsx(Typography, {
                component: "div",
                typography: "subtitle1",
                color: theme.palette.blackAndWhite.white,
                children: text
            })
        ]
    });
});
IconWithSnackbarMessage.displayName = "IconWithSnackbarMessage";
const SnackbarMessage = styled("div")(_templateObject());
export const defaultSnackbarProps = {
    autoHideDuration: 3000,
    anchorOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    style: {
        top: 88
    }
};
export const BrandSnackbar = styled(Snackbar)((param)=>{
    let { theme  } = param;
    return {
        ...theme.typography.subtitle1,
        backgroundColor: theme.palette.grey[700],
        width: "fit-content",
        minWidth: "320px",
        padding: "12px 12px",
        fontSize: "16px",
        borderRadius: "6px",
        textAlign: "left",
        justifyContent: "flex-start",
        [theme.breakpoints.down("sm")]: {
            left: "50%",
            transform: "translateX(-50%)"
        }
    };
});
